import { BeatCardFooterButton } from "@evt/beat";

export const options = [
  {
    textBody: "Você tem 5 documentos em aberto que somam R$49.432,49",
    footerContents: <BeatCardFooterButton> &gt; </BeatCardFooterButton>,
  },
  {
    textBody: "Você tem 2 documentos vencidos que somam R$29.432,49",
    footerContents: <BeatCardFooterButton> &gt; </BeatCardFooterButton>,
  },
];

export const options2 = [
  {
    textBody: "Você tem 3 documentos à vencer que somam R$19.432,49",
    footerContents: <BeatCardFooterButton> &gt; </BeatCardFooterButton>,
  },

  {
    textBody: "Você tem 50 documentos quitados nos últimos 3 dias que somam R$529.432,49",
    footerContents: <BeatCardFooterButton> &gt; </BeatCardFooterButton>,
  }
];
